module.exports = __webpack_public_path__ + "img/gztc.7a98c0a4.png";